export const SET_MAILS = 'SET_MAILS';
export const SET_SINGLE_MAIL = 'SET_SINGLE_MAIL';
export const SET_MAIL_LOAD_START = 'SET_MAIL_LOAD_START';
export const SET_MAIL_LOAD_STOP = 'SET_MAIL_LOAD_STOP';
export const SET_MAIL_LIST_LOAD_START = 'SET_MAIL_LIST_LOAD_START';
export const SET_MAIL_LIST_LOAD_STOP = 'SET_MAIL_LIST_LOAD_STOP';
